import { PropsWithChildren } from 'react'

function ViewGestureHandler({ children }: PropsWithChildren<unknown>): JSX.Element {
  return <>{children}</>
}

export default ViewGestureHandler
